<template>
    <div
        class="mt-8 btn secondary btn-misc"
        @click="
            $modal.show('add-jewel-modal', {
                data: {},
            })
        "
    >
        <span class="mr-2">{{ title }}</span
        ><i class="fas fa-chevron-right"></i>
    </div>
</template>

<script>
export default {
    props: [],
    data: function () {
        return {
            jewelCount: 0,
        };
    },
    mounted() {
        this.$EventBus.$on("jewel-count", (data) => {
            this.jewelCount = data.count;
        });
    },
    computed: {
        title() {
            return this.jewelCount == 0 ? "Add Diamond" : "Add Another Diamond";
        },
    },
};
</script>

<style></style>
